import { getCurrentInstance } from "vue";

export const useModal = () => {
  const app = getCurrentInstance();

  if (app) {
    return app.proxy.$root.$bvModal;
  }
};
